import React from 'react';
import styled from 'styled-components';

/**
 * Renders CM markup used across the concept tree:
 *  - concept titles mark target-language words with *asterisks* (KLine-md)
 *  - KLine names carry <target>…</target> / <glossary>…</glossary> tags
 * Both are shown in their CM colors (target #2087ff, glossary #2DA4AC).
 */
export const ConceptTitleText: React.FC<{ text: string }> = ({ text }) => {
  const nodes: React.ReactNode[] = [];
  // Split on tags first, then on *asterisks* inside plain runs.
  const tagRe = /<(target|glossary)>([\s\S]*?)<\/\1>/gi;
  let last = 0;
  let key = 0;
  let m: RegExpExecArray | null;
  const pushSingleStars = (plain: string) => {
    plain.split(/\*([^*]+)\*/g).forEach((part, i) => {
      if (part === '') return;
      nodes.push(i % 2 === 1 ? <Target key={key++}>{part}</Target> : <React.Fragment key={key++}>{part}</React.Fragment>);
    });
  };
  const pushPlain = (plain: string) => {
    // **bold** (KLine-md emphasis) FIRST — otherwise the single-star pass eats
    // the inner pair and renders stray asterisks in target color.
    plain.split(/\*\*([^*]+)\*\*/g).forEach((part, i) => {
      if (part === '') return;
      if (i % 2 === 1) {
        nodes.push(<b key={key++}>{part}</b>);
      } else {
        pushSingleStars(part);
      }
    });
  };
  while ((m = tagRe.exec(text)) !== null) {
    if (m.index > last) pushPlain(text.slice(last, m.index));
    const Tag = m[1].toLowerCase() === 'glossary' ? Glossary : Target;
    nodes.push(<Tag key={key++}>{m[2]}</Tag>);
    last = m.index + m[0].length;
  }
  if (last < text.length) pushPlain(text.slice(last));

  return <>{nodes}</>;
};

const Target = styled.span`
  color: #2087ff;
  font-style: italic;
`;

const Glossary = styled.span`
  color: #2da4ac;
`;
